import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { useTheme } from "@mui/material/styles";
const CustomButton = ({ text, onClick,color, width = 'auto', hoverColor , backgroundColor,startIcon,height,  ...props }) => {
  const theme = useTheme();
  const defaultHoverColor = theme.palette.custom?.hoverColor;
  return (
    <MuiButton
      variant="contained"
      size="large"
      startIcon={startIcon}
      onClick={onClick}
      sx={{
        width: width,
        height: height,
        padding: '0.75rem 2rem',
        //fontSize: '1rem',
        //fontWeight: 'bold',
        color: color,
        backgroundColor: backgroundColor ,
        '&:hover': {
          backgroundColor: hoverColor || defaultHoverColor,
        },
        "&:active": {
          transform: "scale(0.98)",
          backgroundColor: hoverColor || backgroundColor,
        },
        "&:focus": {
          backgroundColor: hoverColor || backgroundColor,
        },
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        transition: 'transform 0.2s',
        '&:active': {
          transform: 'scale(0.98)',
        },
      }}
      {...props}
    >
      {text}
    </MuiButton>
  );
};

export default CustomButton;
